"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var axios_1 = __importDefault(require("axios"));
var ProjectTypes_1 = require("Project/ProjectTypes");
var SearchService = (function () {
    function SearchService(apiBaseUrl, limit) {
        if (limit === void 0) { limit = 10; }
        this.apiBaseUrl = apiBaseUrl;
        this.limit = limit;
    }
    SearchService.prototype.searchProjects = function (searchTerm, start) {
        if (start === void 0) { start = 0; }
        return __awaiter(this, void 0, Promise, function () {
            var response, mockResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.apiBaseUrl) return [3, 2];
                        return [4, axios_1.default.get("".concat(this.apiBaseUrl, "/search/projects"), {
                                params: { searchTerm: searchTerm, start: start, limit: this.limit },
                                withCredentials: true,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                    case 2:
                        mockResponse = {
                            count: 20,
                            projects: [
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Live),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Pending),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Accepted),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Archived),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Draft),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Live),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Pending),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Accepted),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Archived),
                                this.fakeProject(ProjectTypes_1.ProjectSearchResultStatus.Draft),
                            ],
                        };
                        return [2, new Promise(function (resolve, reject) {
                                setTimeout(function () { return resolve(mockResponse); }, 200);
                            })];
                }
            });
        });
    };
    SearchService.prototype.fakeProject = function (status) {
        var names = (0, lodash_1.shuffle)([
            'name <span class="search-card__highlight">match</span>  kajsdbfkajbsdkjfbas dj',
            'this is a project with a very very very very long name which also has a \
      <span class="search-card__highlight">match</span> in name',
        ]);
        return {
            name: names[0],
            highlight: {
                blockContents: (0, lodash_1.shuffle)([
                    'hey hey <span class="search-card__highlight">match</span> hey \
          this is very cool text match that we got from our backend using \
          our uber cool seearch service which is powered by elastic search \
          which is one hell of a great open source project',
                    "normal match with no highlight",
                    'et tu <span class="search-card__highlight">match</span> ey',
                ]),
                name: names,
            },
            status: status,
            _id: Math.random().toString(),
            links: [
                {
                    name: "Default Link",
                    secret: "IEE6NVRdSH6p",
                },
                {
                    name: "Default Link",
                    secret: "IEE6NVRdSH6p",
                },
            ],
            $userAction: "all",
            hasTemplateChildren: false,
        };
    };
    SearchService.prototype.getProject = function (projectId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.get("".concat(this.apiBaseUrl, "/projects/").concat(projectId), { withCredentials: true })];
                    case 1:
                        response = _a.sent();
                        return [2, response.data];
                }
            });
        });
    };
    return SearchService;
}());
exports.default = SearchService;
